/* ============================================================
   Video Reviews Slider — av-video-reviews.js
   Save to: Assets/av-video-reviews.js

   Handles:
     - Horizontal scroll navigation via arrows
     - Auto show/hide arrows when content overflows
     - Click on video card → open lightbox, play with audio
     - Lightbox close (X button, overlay click, Escape key)
   ============================================================ */

(function () {
  'use strict';

  function initCarousel(carousel) {
    const trackWrap = carousel.querySelector('.av-vr__track-wrap');
    const track = carousel.querySelector('.av-vr__track');
    if (!trackWrap || !track) return;

    const section = carousel.closest('.av-vr');
    const prevBtn = section.querySelector(`.av-vr__arrow--prev[data-vr-target="${carousel.id}"]`);
    const nextBtn = section.querySelector(`.av-vr__arrow--next[data-vr-target="${carousel.id}"]`);

    function updateArrows() {
      if (!prevBtn && !nextBtn) return;
      const needsScroll = trackWrap.scrollWidth > trackWrap.clientWidth + 2;
      if (prevBtn) prevBtn.style.display = needsScroll ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = needsScroll ? 'flex' : 'none';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const step = Math.round(trackWrap.clientWidth * 0.8);
        trackWrap.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const step = Math.round(trackWrap.clientWidth * 0.8);
        trackWrap.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 120);
    });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => updateArrows());
      ro.observe(track);
    }

    updateArrows();
    setTimeout(updateArrows, 300);
  }

  function initLightbox() {
    const lightbox = document.getElementById('av-vr-lightbox');
    if (!lightbox) return;

    const video = document.getElementById('av-vr-lightbox-video');
    const closeTriggers = lightbox.querySelectorAll('[data-vr-close]');

    document.addEventListener('click', (e) => {
      if (e.target.closest('.av-vr__tag')) return;

      const trigger = e.target.closest('.av-vr__media');
      if (!trigger) return;

      const src = trigger.dataset.vrSrc;
      if (!src) return;

      e.preventDefault();

      video.src = src;
      const poster = trigger.dataset.vrPoster;
      if (poster) video.poster = poster;
      video.muted = false;
      video.currentTime = 0;

      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          video.muted = true;
          video.play();
        });
      }
    });

    function closeLightbox() {
      video.pause();
      video.src = '';
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }

    closeTriggers.forEach(el => {
      el.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.style.display === 'flex') {
        closeLightbox();
      }
    });
  }

  /* Lazy-load in-feed videos: attach src + play only when scrolled near the
     viewport, pause when out of view. Videos never load if autoplay is off
     (the poster image stands in; clicking still opens the full lightbox). */
  function playInView(v) {
    if (!v.src && v.dataset.vrVideoSrc) {
      v.src = v.dataset.vrVideoSrc;
      v.load();
    }
    const p = v.play();
    if (p !== undefined) p.catch(() => {});
  }

  function initLazyVideos() {
    const vids = document.querySelectorAll('.av-vr__video[data-vr-video-src]');
    if (!vids.length) return;

    const isAutoplay = (v) => {
      const car = v.closest('.av-vr__carousel');
      return car && car.dataset.vrAutoplay === 'true';
    };

    if (typeof IntersectionObserver === 'undefined') {
      vids.forEach(v => { if (isAutoplay(v)) playInView(v); });
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting) {
          if (isAutoplay(v)) playInView(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0.1 });

    vids.forEach(v => io.observe(v));
  }

  function init() {
    const carousels = document.querySelectorAll('.av-vr__carousel');
    carousels.forEach(initCarousel);
    // Full-screen lightbox/popup is intentionally disabled — clicking a review
    // video no longer opens it. Videos play inline (muted autoplay) only.
    // initLightbox();
    initLazyVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
